export default class customSelect {

    constructor(selectWrap) {
        this.selectWrap = selectWrap;

        this.select = this.selectWrap.querySelector('select');

        this.options = this.select.querySelectorAll('option');
        this.selectedOption = this.select.querySelector('option[selected]');
        this.selectedOptionText = this.selectedOption ? this.selectedOption.textContent : this.options[0].textContent;

        this.dropdown = document.createElement('div');
        this.dropdown.classList.add('select-dropdown');
        this.dropdownList = document.createElement('ul');

        this.init();
    }

    init() {
        if (!this.selectWrap.classList.contains('initialized') && this.options.length > 0) {

            this.selectWrap.insertAdjacentHTML('beforeend', `
                <div class="select-trigger" data-placeholder="${this.options[0].textContent}">
                    <span>${this.selectedOptionText}</span>
                    <svg>
                        <use xlink:href="${theme_dir}/dist/img/svgsprite/svgsprite.svg#select-arrow"></use>
                    </svg>
                </div>
            `);

            this.generateDropdownList();

            this.dropdown.append(this.dropdownList);
            this.selectWrap.append(this.dropdown);

            this.bindSelectTrigger()

            this.bindSelectItems()

            this.selectWrap.classList.add('initialized')

        } else {
            console.log("Select is empty or has been initialized!");
        }
    }

    generateDropdownList() {
        this.options.forEach(option => {
            if (option.hasAttribute('hidden')) {
                this.dropdownList.innerHTML += `
                    <li class="hidden">${option.textContent}</li>
                `;
            } else {
                this.dropdownList.innerHTML += `
                    <li>${option.textContent}</li>
                `;
            }
        });
    }

    bindSelectTrigger() {
        const selectTrigger = this.selectWrap.querySelector('.select-trigger');
        selectTrigger.addEventListener('click', function (e) {
            if (!selectTrigger.classList.contains('dropdown-active') && document.querySelector('.dropdown-active')) {
                document.querySelector('.dropdown-active').click();
            }

            this.classList.toggle('active');
            this.classList.toggle('dropdown-active');
            this.nextElementSibling.classList.toggle('active');

        });
    }

    bindSelectItems() {
        const dropdownListItems = this.dropdownList.querySelectorAll('li');
        dropdownListItems.forEach((item, index) => {
            item.addEventListener('click', () => {
                const select = this.select,
                    selectTrigger = this.selectWrap.querySelector('.select-trigger');

                select.selectedIndex = index
                select.dispatchEvent(new Event('change'));

                selectTrigger.querySelector('span').textContent = item.textContent;
                selectTrigger.click();
                selectTrigger.classList.add('choice-made')
            });
        });
    }
}